import type { iBMS_dn_BMS_EXHIBITOR_INFO, iBMS_iu_BMS_EXHIBITOR_INFO } from "../models/requestdto"
import type { BMS_dn_BMS_EXHIBITOR_INFO, BMS_iu_BMS_EXHIBITOR_INFO } from "../models/responsedto"
import { FmsApi } from "../fmsapi"
import BaseController from "./base"

export class BmsController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "bms")
  }

  public async BMS_iu_BMS_EXHIBITOR_INFO(params: iBMS_iu_BMS_EXHIBITOR_INFO): Promise<BMS_iu_BMS_EXHIBITOR_INFO> {
    return await this.callApi("BMS_iu_BMS_EXHIBITOR_INFO", params)
  }

  public async BMS_dn_BMS_EXHIBITOR_INFO(params: iBMS_dn_BMS_EXHIBITOR_INFO): Promise<BMS_dn_BMS_EXHIBITOR_INFO> {
    return await this.callApi("BMS_dn_BMS_EXHIBITOR_INFO", params)
  }
}
